// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "datamanagement/internalapi/v1/data.proto" (package "datamanagement.internalapi.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private data managment RPCs and protos
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Sequence } from "../../../app/data/v1/data";
import { TagsFilter } from "../../../app/data/v1/data";
import { SequenceResourceFilter } from "../../../app/data/v1/data";
import { BinaryData } from "../../../app/data/v1/data";
import { Order } from "../../../app/data/v1/data";
import { Filter } from "../../../app/data/v1/data";
import { OnlineState } from "../../../app/v1/app";
import { Struct } from "../../../google/protobuf/struct";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { IndexCreator } from "../../../app/data/v1/data";
import { IndexableCollection as IndexableCollection$ } from "../../../app/data/v1/data";
/**
 * @generated from protobuf message datamanagement.internalapi.v1.IndexWithStatus
 */
export interface IndexWithStatus {
    /**
     * @generated from protobuf field: viam.app.data.v1.IndexableCollection collection_type = 1;
     */
    collectionType: IndexableCollection$;
    /**
     * @generated from protobuf field: optional string pipeline_name = 2;
     */
    pipelineName?: string;
    /**
     * @generated from protobuf field: string index_name = 3;
     */
    indexName: string;
    /**
     * @generated from protobuf field: repeated bytes index_spec = 4;
     */
    indexSpec: Uint8Array[];
    /**
     * @generated from protobuf field: viam.app.data.v1.IndexCreator created_by = 5;
     */
    createdBy: IndexCreator;
    /**
     * @generated from protobuf field: datamanagement.internalapi.v1.IndexBuildStatus status = 6;
     */
    status: IndexBuildStatus;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.ListIndexesWithStatusRequest
 */
export interface ListIndexesWithStatusRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: viam.app.data.v1.IndexableCollection collection_type = 2;
     */
    collectionType: IndexableCollection$;
    /**
     * @generated from protobuf field: optional string pipeline_name = 3;
     */
    pipelineName?: string;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.ListIndexesWithStatusResponse
 */
export interface ListIndexesWithStatusResponse {
    /**
     * @generated from protobuf field: repeated datamanagement.internalapi.v1.IndexWithStatus indexes = 1;
     */
    indexes: IndexWithStatus[];
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.GetLatestTabularDataByPartIDRequest
 */
export interface GetLatestTabularDataByPartIDRequest {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.TabularDataPoint
 */
export interface TabularDataPoint {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * @generated from protobuf field: string resource_name = 2;
     */
    resourceName: string;
    /**
     * @generated from protobuf field: string resource_subtype = 3;
     */
    resourceSubtype: string;
    /**
     * @generated from protobuf field: string method_name = 4;
     */
    methodName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time_captured = 5;
     */
    timeCaptured?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time_synced = 6;
     */
    timeSynced?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Struct payload = 7;
     */
    payload?: Struct;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.GetLatestTabularDataByPartIDResponse
 */
export interface GetLatestTabularDataByPartIDResponse {
    /**
     * @generated from protobuf field: repeated datamanagement.internalapi.v1.TabularDataPoint data_points = 1;
     */
    dataPoints: TabularDataPoint[];
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.GetLatestBinaryDataByPartIDRequest
 */
export interface GetLatestBinaryDataByPartIDRequest {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.BinaryDataPoint
 */
export interface BinaryDataPoint {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * @generated from protobuf field: string resource_name = 2;
     */
    resourceName: string;
    /**
     * @generated from protobuf field: string resource_subtype = 3;
     */
    resourceSubtype: string;
    /**
     * @generated from protobuf field: string method_name = 4;
     */
    methodName: string;
    /**
     * @generated from protobuf field: string mime_type = 5;
     */
    mimeType: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time_captured = 6;
     */
    timeCaptured?: Timestamp;
    /**
     * @generated from protobuf field: string uri = 7;
     */
    uri: string;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.GetLatestBinaryDataByPartIDResponse
 */
export interface GetLatestBinaryDataByPartIDResponse {
    /**
     * @generated from protobuf field: repeated datamanagement.internalapi.v1.BinaryDataPoint data_points = 1;
     */
    dataPoints: BinaryDataPoint[];
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.GetRecentDataStoreConfiguredRequest
 */
export interface GetRecentDataStoreConfiguredRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.GetRecentDataStoreConfiguredResponse
 */
export interface GetRecentDataStoreConfiguredResponse {
    /**
     * @generated from protobuf field: bool configured = 1;
     */
    configured: boolean;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.Location
 */
export interface Location {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string parent_location_id = 3;
     */
    parentLocationId: string;
    /**
     * @generated from protobuf field: repeated string child_location_ids = 4;
     */
    childLocationIds: string[];
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.Machine
 */
export interface Machine {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string location = 3;
     */
    location: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_online = 4;
     */
    lastOnline?: Timestamp;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.MachinePart
 */
export interface MachinePart {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string robot = 3;
     */
    robot: string;
    /**
     * @generated from protobuf field: bool main_part = 4;
     */
    mainPart: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_online = 5;
     */
    lastOnline?: Timestamp;
    /**
     * @generated from protobuf field: string seconds_since_online = 6;
     */
    secondsSinceOnline: string;
    /**
     * @generated from protobuf field: viam.app.v1.OnlineState online_state = 7;
     */
    onlineState: OnlineState;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.GetSensorPageDataRequest
 */
export interface GetSensorPageDataRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.GetSensorPageDataResponse
 */
export interface GetSensorPageDataResponse {
    /**
     * @generated from protobuf field: repeated datamanagement.internalapi.v1.Location locations = 1;
     */
    locations: Location[];
    /**
     * @generated from protobuf field: repeated datamanagement.internalapi.v1.Machine machines = 2;
     */
    machines: Machine[];
    /**
     * @generated from protobuf field: repeated datamanagement.internalapi.v1.MachinePart machine_parts = 3;
     */
    machineParts: MachinePart[];
    /**
     * @generated from protobuf field: repeated datamanagement.internalapi.v1.TabularDataPoint data_points = 4;
     */
    dataPoints: TabularDataPoint[];
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.MachinePartUpdate
 */
export interface MachinePartUpdate {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_online = 5;
     */
    lastOnline?: Timestamp;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.GetSensorPageUpdateRequest
 */
export interface GetSensorPageUpdateRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: repeated string part_ids = 2;
     */
    partIds: string[];
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.GetSensorPageUpdateResponse
 */
export interface GetSensorPageUpdateResponse {
    /**
     * @generated from protobuf field: repeated datamanagement.internalapi.v1.MachinePartUpdate machine_parts = 1;
     */
    machineParts: MachinePartUpdate[];
    /**
     * @generated from protobuf field: repeated datamanagement.internalapi.v1.TabularDataPoint data_points = 2;
     */
    dataPoints: TabularDataPoint[];
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.DataRequestWithExclusionFilter
 */
export interface DataRequestWithExclusionFilter {
    /**
     * @generated from protobuf field: viam.app.data.v1.Filter filter = 1;
     */
    filter?: Filter;
    /**
     * @generated from protobuf field: viam.app.data.v1.Filter exclusion_filter = 2;
     */
    exclusionFilter?: Filter;
    /**
     * @generated from protobuf field: uint64 limit = 3;
     */
    limit: string;
    /**
     * @generated from protobuf field: string last = 4;
     */
    last: string;
    /**
     * @generated from protobuf field: viam.app.data.v1.Order sort_order = 5;
     */
    sortOrder: Order;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.GetBinaryDataByExclusionFilterRequest
 */
export interface GetBinaryDataByExclusionFilterRequest {
    /**
     * @generated from protobuf field: datamanagement.internalapi.v1.DataRequestWithExclusionFilter data_request = 1;
     */
    dataRequest?: DataRequestWithExclusionFilter;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.GetBinaryDataByExclusionFilterResponse
 */
export interface GetBinaryDataByExclusionFilterResponse {
    /**
     * @generated from protobuf field: repeated viam.app.data.v1.BinaryData data = 1;
     */
    data: BinaryData[];
    /**
     * @generated from protobuf field: uint64 count = 2;
     */
    count: string;
    /**
     * @generated from protobuf field: string last = 3;
     */
    last: string;
    /**
     * @generated from protobuf field: uint64 total_size_bytes = 4;
     */
    totalSizeBytes: string;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.DeleteBinaryDataByExclusionFilterRequest
 */
export interface DeleteBinaryDataByExclusionFilterRequest {
    /**
     * @generated from protobuf field: viam.app.data.v1.Filter filter = 1;
     */
    filter?: Filter;
    /**
     * @generated from protobuf field: viam.app.data.v1.Filter exclusion_filter = 2;
     */
    exclusionFilter?: Filter;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.DeleteBinaryDataByExclusionFilterResponse
 */
export interface DeleteBinaryDataByExclusionFilterResponse {
    /**
     * @generated from protobuf field: uint64 deleted_count = 1;
     */
    deletedCount: string;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.AddBinaryDataToDatasetByFilterRequest
 */
export interface AddBinaryDataToDatasetByFilterRequest {
    /**
     * @generated from protobuf field: viam.app.data.v1.Filter filter = 1;
     */
    filter?: Filter;
    /**
     * @generated from protobuf field: string dataset_id = 2;
     */
    datasetId: string;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.AddBinaryDataToDatasetByFilterResponse
 */
export interface AddBinaryDataToDatasetByFilterResponse {
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.GetSequenceTabularDataRequest
 */
export interface GetSequenceTabularDataRequest {
    /**
     * @generated from protobuf field: string sequence_id = 1;
     */
    sequenceId: string;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * Optional. When set, narrows results to data captured from this resource.
     *
     * @generated from protobuf field: viam.app.data.v1.SequenceResourceFilter resource = 4;
     */
    resource?: SequenceResourceFilter;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.GetSequenceTabularDataResponse
 */
export interface GetSequenceTabularDataResponse {
    /**
     * @generated from protobuf field: repeated datamanagement.internalapi.v1.TabularDataPoint data_points = 1;
     */
    dataPoints: TabularDataPoint[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.SequenceFilter
 */
export interface SequenceFilter {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * Matches sequences containing any of these resources.
     *
     * @generated from protobuf field: repeated viam.app.data.v1.SequenceResourceFilter resources = 2;
     */
    resources: SequenceResourceFilter[];
    /**
     * @generated from protobuf field: viam.app.data.v1.TagsFilter tags_filter = 3;
     */
    tagsFilter?: TagsFilter;
    /**
     * Matches sequences whose [start_time, end_time] overlaps this window. Either bound may be unset.
     *
     * @generated from protobuf field: google.protobuf.Timestamp start_time = 4;
     */
    startTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_time = 5;
     */
    endTime?: Timestamp;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.ListSequencesByFilterRequest
 */
export interface ListSequencesByFilterRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: datamanagement.internalapi.v1.SequenceFilter filter = 2;
     */
    filter?: SequenceFilter;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: uint32 page_size = 4;
     */
    pageSize: number;
}
/**
 * @generated from protobuf message datamanagement.internalapi.v1.ListSequencesByFilterResponse
 */
export interface ListSequencesByFilterResponse {
    /**
     * @generated from protobuf field: repeated viam.app.data.v1.Sequence sequences = 1;
     */
    sequences: Sequence[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf enum datamanagement.internalapi.v1.IndexBuildStatus
 */
export enum IndexBuildStatus {
    /**
     * @generated from protobuf enum value: INDEX_BUILD_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INDEX_BUILD_STATUS_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: INDEX_BUILD_STATUS_IN_PROGRESS = 2;
     */
    IN_PROGRESS = 2,
    /**
     * @generated from protobuf enum value: INDEX_BUILD_STATUS_SUCCEEDED = 3;
     */
    SUCCEEDED = 3,
    /**
     * @generated from protobuf enum value: INDEX_BUILD_STATUS_FAILED = 4;
     */
    FAILED = 4,
    /**
     * @deprecated
     * @generated from protobuf enum value: INDEX_BUILD_STATUS_DELETED = 5 [deprecated = true];
     */
    DELETED = 5
}
/**
 * @generated from protobuf enum datamanagement.internalapi.v1.IndexableCollection
 */
export enum IndexableCollection {
    /**
     * @generated from protobuf enum value: INDEXABLE_COLLECTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INDEXABLE_COLLECTION_HOT_STORE = 1;
     */
    HOT_STORE = 1,
    /**
     * @generated from protobuf enum value: INDEXABLE_COLLECTION_PIPELINE_SINK = 2;
     */
    PIPELINE_SINK = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class IndexWithStatus$Type extends MessageType<IndexWithStatus> {
    constructor() {
        super("datamanagement.internalapi.v1.IndexWithStatus", [
            { no: 1, name: "collection_type", kind: "enum", T: () => ["viam.app.data.v1.IndexableCollection", IndexableCollection$, "INDEXABLE_COLLECTION_"] },
            { no: 2, name: "pipeline_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "index_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "index_spec", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 12 /*ScalarType.BYTES*/ },
            { no: 5, name: "created_by", kind: "enum", T: () => ["viam.app.data.v1.IndexCreator", IndexCreator, "INDEX_CREATOR_"] },
            { no: 6, name: "status", kind: "enum", T: () => ["datamanagement.internalapi.v1.IndexBuildStatus", IndexBuildStatus, "INDEX_BUILD_STATUS_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.IndexWithStatus
 */
export const IndexWithStatus = new IndexWithStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListIndexesWithStatusRequest$Type extends MessageType<ListIndexesWithStatusRequest> {
    constructor() {
        super("datamanagement.internalapi.v1.ListIndexesWithStatusRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "collection_type", kind: "enum", T: () => ["viam.app.data.v1.IndexableCollection", IndexableCollection$, "INDEXABLE_COLLECTION_"] },
            { no: 3, name: "pipeline_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.ListIndexesWithStatusRequest
 */
export const ListIndexesWithStatusRequest = new ListIndexesWithStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListIndexesWithStatusResponse$Type extends MessageType<ListIndexesWithStatusResponse> {
    constructor() {
        super("datamanagement.internalapi.v1.ListIndexesWithStatusResponse", [
            { no: 1, name: "indexes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => IndexWithStatus }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.ListIndexesWithStatusResponse
 */
export const ListIndexesWithStatusResponse = new ListIndexesWithStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLatestTabularDataByPartIDRequest$Type extends MessageType<GetLatestTabularDataByPartIDRequest> {
    constructor() {
        super("datamanagement.internalapi.v1.GetLatestTabularDataByPartIDRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.GetLatestTabularDataByPartIDRequest
 */
export const GetLatestTabularDataByPartIDRequest = new GetLatestTabularDataByPartIDRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TabularDataPoint$Type extends MessageType<TabularDataPoint> {
    constructor() {
        super("datamanagement.internalapi.v1.TabularDataPoint", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "resource_subtype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "method_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "time_captured", kind: "message", T: () => Timestamp },
            { no: 6, name: "time_synced", kind: "message", T: () => Timestamp },
            { no: 7, name: "payload", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.TabularDataPoint
 */
export const TabularDataPoint = new TabularDataPoint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLatestTabularDataByPartIDResponse$Type extends MessageType<GetLatestTabularDataByPartIDResponse> {
    constructor() {
        super("datamanagement.internalapi.v1.GetLatestTabularDataByPartIDResponse", [
            { no: 1, name: "data_points", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TabularDataPoint }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.GetLatestTabularDataByPartIDResponse
 */
export const GetLatestTabularDataByPartIDResponse = new GetLatestTabularDataByPartIDResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLatestBinaryDataByPartIDRequest$Type extends MessageType<GetLatestBinaryDataByPartIDRequest> {
    constructor() {
        super("datamanagement.internalapi.v1.GetLatestBinaryDataByPartIDRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.GetLatestBinaryDataByPartIDRequest
 */
export const GetLatestBinaryDataByPartIDRequest = new GetLatestBinaryDataByPartIDRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BinaryDataPoint$Type extends MessageType<BinaryDataPoint> {
    constructor() {
        super("datamanagement.internalapi.v1.BinaryDataPoint", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "resource_subtype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "method_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "time_captured", kind: "message", T: () => Timestamp },
            { no: 7, name: "uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.BinaryDataPoint
 */
export const BinaryDataPoint = new BinaryDataPoint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLatestBinaryDataByPartIDResponse$Type extends MessageType<GetLatestBinaryDataByPartIDResponse> {
    constructor() {
        super("datamanagement.internalapi.v1.GetLatestBinaryDataByPartIDResponse", [
            { no: 1, name: "data_points", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BinaryDataPoint }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.GetLatestBinaryDataByPartIDResponse
 */
export const GetLatestBinaryDataByPartIDResponse = new GetLatestBinaryDataByPartIDResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRecentDataStoreConfiguredRequest$Type extends MessageType<GetRecentDataStoreConfiguredRequest> {
    constructor() {
        super("datamanagement.internalapi.v1.GetRecentDataStoreConfiguredRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.GetRecentDataStoreConfiguredRequest
 */
export const GetRecentDataStoreConfiguredRequest = new GetRecentDataStoreConfiguredRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRecentDataStoreConfiguredResponse$Type extends MessageType<GetRecentDataStoreConfiguredResponse> {
    constructor() {
        super("datamanagement.internalapi.v1.GetRecentDataStoreConfiguredResponse", [
            { no: 1, name: "configured", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.GetRecentDataStoreConfiguredResponse
 */
export const GetRecentDataStoreConfiguredResponse = new GetRecentDataStoreConfiguredResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Location$Type extends MessageType<Location> {
    constructor() {
        super("datamanagement.internalapi.v1.Location", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "parent_location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "child_location_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.Location
 */
export const Location = new Location$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Machine$Type extends MessageType<Machine> {
    constructor() {
        super("datamanagement.internalapi.v1.Machine", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "last_online", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.Machine
 */
export const Machine = new Machine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MachinePart$Type extends MessageType<MachinePart> {
    constructor() {
        super("datamanagement.internalapi.v1.MachinePart", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "robot", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "main_part", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "last_online", kind: "message", T: () => Timestamp },
            { no: 6, name: "seconds_since_online", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "online_state", kind: "enum", T: () => ["viam.app.v1.OnlineState", OnlineState, "ONLINE_STATE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.MachinePart
 */
export const MachinePart = new MachinePart$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSensorPageDataRequest$Type extends MessageType<GetSensorPageDataRequest> {
    constructor() {
        super("datamanagement.internalapi.v1.GetSensorPageDataRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.GetSensorPageDataRequest
 */
export const GetSensorPageDataRequest = new GetSensorPageDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSensorPageDataResponse$Type extends MessageType<GetSensorPageDataResponse> {
    constructor() {
        super("datamanagement.internalapi.v1.GetSensorPageDataResponse", [
            { no: 1, name: "locations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Location },
            { no: 2, name: "machines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Machine },
            { no: 3, name: "machine_parts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MachinePart },
            { no: 4, name: "data_points", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TabularDataPoint }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.GetSensorPageDataResponse
 */
export const GetSensorPageDataResponse = new GetSensorPageDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MachinePartUpdate$Type extends MessageType<MachinePartUpdate> {
    constructor() {
        super("datamanagement.internalapi.v1.MachinePartUpdate", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "last_online", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.MachinePartUpdate
 */
export const MachinePartUpdate = new MachinePartUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSensorPageUpdateRequest$Type extends MessageType<GetSensorPageUpdateRequest> {
    constructor() {
        super("datamanagement.internalapi.v1.GetSensorPageUpdateRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "part_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.GetSensorPageUpdateRequest
 */
export const GetSensorPageUpdateRequest = new GetSensorPageUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSensorPageUpdateResponse$Type extends MessageType<GetSensorPageUpdateResponse> {
    constructor() {
        super("datamanagement.internalapi.v1.GetSensorPageUpdateResponse", [
            { no: 1, name: "machine_parts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MachinePartUpdate },
            { no: 2, name: "data_points", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TabularDataPoint }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.GetSensorPageUpdateResponse
 */
export const GetSensorPageUpdateResponse = new GetSensorPageUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataRequestWithExclusionFilter$Type extends MessageType<DataRequestWithExclusionFilter> {
    constructor() {
        super("datamanagement.internalapi.v1.DataRequestWithExclusionFilter", [
            { no: 1, name: "filter", kind: "message", T: () => Filter },
            { no: 2, name: "exclusion_filter", kind: "message", T: () => Filter },
            { no: 3, name: "limit", kind: "scalar", T: 4 /*ScalarType.UINT64*/ },
            { no: 4, name: "last", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "sort_order", kind: "enum", T: () => ["viam.app.data.v1.Order", Order, "ORDER_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.DataRequestWithExclusionFilter
 */
export const DataRequestWithExclusionFilter = new DataRequestWithExclusionFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBinaryDataByExclusionFilterRequest$Type extends MessageType<GetBinaryDataByExclusionFilterRequest> {
    constructor() {
        super("datamanagement.internalapi.v1.GetBinaryDataByExclusionFilterRequest", [
            { no: 1, name: "data_request", kind: "message", T: () => DataRequestWithExclusionFilter }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.GetBinaryDataByExclusionFilterRequest
 */
export const GetBinaryDataByExclusionFilterRequest = new GetBinaryDataByExclusionFilterRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBinaryDataByExclusionFilterResponse$Type extends MessageType<GetBinaryDataByExclusionFilterResponse> {
    constructor() {
        super("datamanagement.internalapi.v1.GetBinaryDataByExclusionFilterResponse", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BinaryData },
            { no: 2, name: "count", kind: "scalar", T: 4 /*ScalarType.UINT64*/ },
            { no: 3, name: "last", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "total_size_bytes", kind: "scalar", T: 4 /*ScalarType.UINT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.GetBinaryDataByExclusionFilterResponse
 */
export const GetBinaryDataByExclusionFilterResponse = new GetBinaryDataByExclusionFilterResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBinaryDataByExclusionFilterRequest$Type extends MessageType<DeleteBinaryDataByExclusionFilterRequest> {
    constructor() {
        super("datamanagement.internalapi.v1.DeleteBinaryDataByExclusionFilterRequest", [
            { no: 1, name: "filter", kind: "message", T: () => Filter },
            { no: 2, name: "exclusion_filter", kind: "message", T: () => Filter }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.DeleteBinaryDataByExclusionFilterRequest
 */
export const DeleteBinaryDataByExclusionFilterRequest = new DeleteBinaryDataByExclusionFilterRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBinaryDataByExclusionFilterResponse$Type extends MessageType<DeleteBinaryDataByExclusionFilterResponse> {
    constructor() {
        super("datamanagement.internalapi.v1.DeleteBinaryDataByExclusionFilterResponse", [
            { no: 1, name: "deleted_count", kind: "scalar", T: 4 /*ScalarType.UINT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.DeleteBinaryDataByExclusionFilterResponse
 */
export const DeleteBinaryDataByExclusionFilterResponse = new DeleteBinaryDataByExclusionFilterResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddBinaryDataToDatasetByFilterRequest$Type extends MessageType<AddBinaryDataToDatasetByFilterRequest> {
    constructor() {
        super("datamanagement.internalapi.v1.AddBinaryDataToDatasetByFilterRequest", [
            { no: 1, name: "filter", kind: "message", T: () => Filter },
            { no: 2, name: "dataset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.AddBinaryDataToDatasetByFilterRequest
 */
export const AddBinaryDataToDatasetByFilterRequest = new AddBinaryDataToDatasetByFilterRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddBinaryDataToDatasetByFilterResponse$Type extends MessageType<AddBinaryDataToDatasetByFilterResponse> {
    constructor() {
        super("datamanagement.internalapi.v1.AddBinaryDataToDatasetByFilterResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.AddBinaryDataToDatasetByFilterResponse
 */
export const AddBinaryDataToDatasetByFilterResponse = new AddBinaryDataToDatasetByFilterResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSequenceTabularDataRequest$Type extends MessageType<GetSequenceTabularDataRequest> {
    constructor() {
        super("datamanagement.internalapi.v1.GetSequenceTabularDataRequest", [
            { no: 1, name: "sequence_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "resource", kind: "message", T: () => SequenceResourceFilter }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.GetSequenceTabularDataRequest
 */
export const GetSequenceTabularDataRequest = new GetSequenceTabularDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSequenceTabularDataResponse$Type extends MessageType<GetSequenceTabularDataResponse> {
    constructor() {
        super("datamanagement.internalapi.v1.GetSequenceTabularDataResponse", [
            { no: 1, name: "data_points", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TabularDataPoint },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.GetSequenceTabularDataResponse
 */
export const GetSequenceTabularDataResponse = new GetSequenceTabularDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SequenceFilter$Type extends MessageType<SequenceFilter> {
    constructor() {
        super("datamanagement.internalapi.v1.SequenceFilter", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SequenceResourceFilter },
            { no: 3, name: "tags_filter", kind: "message", T: () => TagsFilter },
            { no: 4, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 5, name: "end_time", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.SequenceFilter
 */
export const SequenceFilter = new SequenceFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSequencesByFilterRequest$Type extends MessageType<ListSequencesByFilterRequest> {
    constructor() {
        super("datamanagement.internalapi.v1.ListSequencesByFilterRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "filter", kind: "message", T: () => SequenceFilter },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "page_size", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.ListSequencesByFilterRequest
 */
export const ListSequencesByFilterRequest = new ListSequencesByFilterRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSequencesByFilterResponse$Type extends MessageType<ListSequencesByFilterResponse> {
    constructor() {
        super("datamanagement.internalapi.v1.ListSequencesByFilterResponse", [
            { no: 1, name: "sequences", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Sequence },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datamanagement.internalapi.v1.ListSequencesByFilterResponse
 */
export const ListSequencesByFilterResponse = new ListSequencesByFilterResponse$Type();
/**
 * @generated ServiceType for protobuf service datamanagement.internalapi.v1.InternalDataService
 */
export const InternalDataService = new ServiceType("datamanagement.internalapi.v1.InternalDataService", [
    { name: "GetLatestBinaryDataByPartID", options: {}, I: GetLatestBinaryDataByPartIDRequest, O: GetLatestBinaryDataByPartIDResponse },
    { name: "GetLatestTabularDataByPartID", options: {}, I: GetLatestTabularDataByPartIDRequest, O: GetLatestTabularDataByPartIDResponse },
    { name: "GetRecentDataStoreConfigured", options: {}, I: GetRecentDataStoreConfiguredRequest, O: GetRecentDataStoreConfiguredResponse },
    { name: "GetSensorPageData", options: {}, I: GetSensorPageDataRequest, O: GetSensorPageDataResponse },
    { name: "GetSensorPageUpdate", options: {}, I: GetSensorPageUpdateRequest, O: GetSensorPageUpdateResponse },
    { name: "GetBinaryDataByExclusionFilter", options: {}, I: GetBinaryDataByExclusionFilterRequest, O: GetBinaryDataByExclusionFilterResponse },
    { name: "AddBinaryDataToDatasetByFilter", options: {}, I: AddBinaryDataToDatasetByFilterRequest, O: AddBinaryDataToDatasetByFilterResponse },
    { name: "DeleteBinaryDataByExclusionFilter", options: {}, I: DeleteBinaryDataByExclusionFilterRequest, O: DeleteBinaryDataByExclusionFilterResponse },
    { name: "GetSequenceTabularData", options: {}, I: GetSequenceTabularDataRequest, O: GetSequenceTabularDataResponse },
    { name: "ListIndexesWithStatus", options: {}, I: ListIndexesWithStatusRequest, O: ListIndexesWithStatusResponse },
    { name: "ListSequencesByFilter", options: {}, I: ListSequencesByFilterRequest, O: ListSequencesByFilterResponse }
]);
